import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRoutes } from './routes';
import { AppProvider } from 'common/contexts';
import {
  AlertProvider,
  AuthProvider,
  MUIThemeProvider,
} from 'common/providers';
import { Toaster } from 'react-hot-toast';

import './App.scss';

function App() {
  const queryClient = new QueryClient();
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <MUIThemeProvider>
          <AlertProvider>
            <AuthProvider>
              <AppProvider>
                <AppRoutes />
                <Toaster position="top-right" reverseOrder={false} />
              </AppProvider>
            </AuthProvider>
          </AlertProvider>
        </MUIThemeProvider>
      </QueryClientProvider>
    </React.Fragment>
  );
}

export default App;
